import {Injectable} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgApplicationTab} from 'exc-tab-v2';
import {TaskWorkspaceComponent} from '../task/task-workspace/task-workspace.component';
import {ModalNewTaskComponent} from '../task/modal/modal-new-task/modal-new-task.component';
import {ReceiptCheckviewComponent} from '../receipt/receipt-checkview.component';
import {ReceiptCollectionCheckviewViewerComponent} from '../receipt/receipt-collection-checkview-viewer.component';
import {TabMessageReadComponent} from '../message/tab/tab-message-read/tab-message-read.component';
import {TabMessageNewFortaskComponent} from '../message/tab/tab-message-new-fortask/tab-message-new-fortask.component';
import {TabMessageNewForcaseComponent} from '../message/tab/tab-message-new-forcase/tab-message-new-forcase.component';
import {ExcRestService} from 'exc-rest-v2';
import {forkJoin, Observable, of, Subscription} from 'rxjs';
import {ExgModalService, ExgOverlayService} from 'exc-controls-v2';
import {ExgAppControllerConfig} from '../misc/classes/ExgAppControllerConfig';
import {TabMessageAnswerForwardComponent} from '../message/tab/tab-message-answer-forward/tab-message-answer-forward.component';
import {EnumerationService} from './enumeration.service';
import {CaseWorkspaceComponent} from '../case/case-workspace/case-workspace.component';
import {WorkflowComponent} from '../workflow/workflow.component';
import {ExcSecurityService} from 'exc-security-v2';
import {ReceiptObjectEditorComponent} from '../receipt/modal/receipt-object-editor.component';
import {mergeMap} from 'rxjs/operators';
import {SettingsApplicationService} from './settings-application.service';
import {QuestionnaireRendererComponent} from '../Questionnaire/questionnaire-renderer/questionnaire-renderer.component';
import {ExgPhotoDocumentationComponent} from '../misc/exg-photo-documentation/exg-photo-documentation.component';
import {OeWorkspaceComponent} from '../oe/oe-workspace.component';
import {CaseCreatorComponent} from '../case/case-creator/case-creator.component';
import {CaseWorkspaceV2Component} from '../case/case-workspace-v2/case-workspace-v2.component';
import {TaskWorkspaceV2Component} from '../task/task-workspace-v2/task-workspace-v2.component';
import {ReportDocBuilderComponent} from '../reportbuilder/report-doc-builder/report-doc-builder.component';
import {ReceiptStatementCheckviewComponent} from '../receipt-statement/receipt-statement-checkview.component';
import {CalculationVersionComponent} from '../Calculation/calculation-version/calculation-version.component';
import {FormularVersionComponent} from '../formular/formular-version.component';
import {LeistungserfassungCheckviewComponent} from '../leistungserfassung/leistungserfassung-checkview.component';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService extends ExcTranslation {
  Task = {
    Workspace: {
      OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...',
          TaskWorkspaceComponent,
          data,
          data,
          undefined,
          true
        );
        tab.Open();
        return tab;
      },
      OpenTabV2: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...',
          TaskWorkspaceV2Component,
          data,
          data,
          undefined,
          true
        );
        tab.Open();
        return tab;
      }
    },
    New: {
      OpenModal: (data: any, config?: ExgAppControllerConfig): Subscription => {
        return this.modalSrv.show('ModalNewTaskComponent', data).subscribe((ret: any) => {
          if (ret) {
            config?.Events?.Task.New.DataLoaded?.emit({success: ret});
          }
        });
      }
    },
    PhotoDocumentation: {
      OpenTab: (data: { FKID?: string | number | undefined, pdData?: string
                  , pdID?: string, pdDescription?: string, pdPhotoDocumentationStatus_enmIdent?: number
                        pdName?: string, pdUPT?: string, aueSchadenNr?: string
                      },
                config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tabData = {
          ...data,
          Events: config?.Events
        };
        const tab = new ExgApplicationTab(
          'loading...',
          ExgPhotoDocumentationComponent,
          tabData,
          data.FKID + 'PhotoDoc' + data.pdID,
          {
            Close: () => {
              config?.Events?.PhotoDocumentation?.Closed?.emit();
            }
          },
          true,
          'fal fa-file-image'
        );
        tab.Open();
        return tab;
      },
    }
  };
  Case = {
    Workspace: {
      OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...',
          CaseWorkspaceComponent,
          data,
          data,
          undefined,
          true
        );
        tab.Open();
        return tab;
      },
      OpenTabV2: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...',
          CaseWorkspaceV2Component,
          data,
          data,
          undefined,
          true
        );
        tab.Open();
        return tab;
      }
    },
    NewTask: {
      OpenTab: (data?: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...',
          WorkflowComponent,
          data,
          ExcCoreModule.Guid.NewGuid(),
          undefined,
          true
        );
        tab.Open();
        return tab;
      }
    },
    NewCase: {
      OpenTab: (data: { auID: string, wert1914Faktor: number, auNr: string, linkedID?: string }
              , config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...',
          CaseCreatorComponent,
          data,
          'CaseCreator' + ExcCoreModule.Guid.NewGuid(),
          {
            Close: () => {
              config?.Events?.Case?.NewCase?.Closed?.emit();
            }
          },
          true,
          'fal fa-file-plus'
        );
        tab.Open();
        return tab;
      }
    }
  };

  Leistungserfassung = {
    New: (data: {fkID: string, fkType: string}, config?: ExgAppControllerConfig): Subscription => {
      return this.modalSrv.show('ModalLeistungNameComponent', {
        headerText: this.getRessource('NewServiceRecord.HeaderText'),
        caption: this.getRessource('NewServiceRecord.Caption'),
        buttonText: this.getGlobal('Create'),
        name: ''
      }).subscribe((rtVal: any) => {
        if (rtVal) {
          this.excRest.post(
            this.excRest.computeUrl('LeistungserfassungCreate', {}),
            {name: rtVal.name, fkid: data.fkID, FKType: data.fkType}
          ).subscribe((rslt: any) => {
            if (rslt?.data?.HeaderData) {
              config?.Events?.Leistungserfassung?.New?.Save.emit({success: true, data: rslt.data.HeaderData});
              this.Leistungserfassung.Checkview.OpenTab(rslt.data.HeaderData);
            }
          });
        }
      });
    },
    Checkview: {
      OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          data.leNr || data.leName, LeistungserfassungCheckviewComponent,
          {leID: data.leID, leNr: data.leNr, leName: data.leName}, data.leID,
          undefined, true, 'fal fa-euro-sign');
        tab.Open();
        return tab;
      }
    }
  };

  Calculation = {
    Version: {
      OpenTab: (data: any,  config?: ExgAppControllerConfig): ExgApplicationTab => {
        data.Events = config?.Events;
        const tab = new ExgApplicationTab(
          'loading...',
          CalculationVersionComponent,
          data,
          data.cvID ?? data.cv_ctID
          , {
            Close: () => {
              config?.Events?.Calculation?.Version?.Closed?.emit();
            }
          },
          true
        );
        tab.Open();
        return tab;
      }
    }
  };
  DialogueQuestion = {
    OpenModal: (data: any, config?: ExgAppControllerConfig): Subscription => {
      return this.modalSrv.show('ModalDialogueQuestionsComponent', data)
        .subscribe(
          (rtVal: any) => {
            if (rtVal) {
              this.excRest.post(
                this.excRest.computeUrl('DialogErgebnisCU', {oid: data.vorgID}), rtVal
              ).subscribe((ret: any) => {
                if (ret) {
                  this.modalSrv
                    .showToast(
                      ret
                        ? this.getGlobal('Success')
                        : this.getGlobal('Abbruch')
                      , 'md-toast'
                      , ret ? 'fad fa-cloud-upload-alt' : 'fal fa-times-circle');
                  config?.Events?.DialogueQuestion?.DataLoaded?.emit({success: ret});
                }
              });
            }
          });
    }
  };
  Schedule = {
    Create: {
      OpenModal: (data: any, config?: ExgAppControllerConfig): Subscription => {
        return this.modalSrv.show('ModalNewTaskWorklistComponent', data).subscribe((ret: any) => {
          if (ret) {
            config?.Events?.Schedule.CreateSchedule.Closed.emit({success: ret});
          }
        });
      }
    },
    Update: {
      OpenModal: (data: any, config?: ExgAppControllerConfig): Subscription => {
        return this.modalSrv.show('ModalTaskWorklistComponent', data).subscribe((ret: any) => {
          if (ret) {
            config?.Events?.Schedule.UpdateSchedule.Closed.emit({success: ret});
          }
        });
      }
    }
  };
  Message = {
    Reader: {
      OpenTab: (data: { msgID: string, fkID?: string }, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...',
          TabMessageReadComponent,
          {...data, ...config},
          data.msgID,
          {
            Close: () => {
              config?.Events?.Message?.Reader?.Closed?.emit();
            }
          },
          true
        );
        tab.Open();
        return tab;
      }
    },
    NewForTask: {
      OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab('loading...'
          , TabMessageNewFortaskComponent
          , data
          , data.objID
          , {
            Events: config?.Events,
            Close: () => {
              config?.Events?.Message?.NewForTask?.Closed?.emit();
            }
          },
          true);
        tab.Open();
        return tab;
      }
    },
    NewForCase: {
      OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab('loading...'
          , TabMessageNewForcaseComponent
          , data
          , data.objID
          , {
            Close: () => {
              config?.Events?.Message?.NewForCase?.Closed?.emit();
            }
          },
          true);
        tab.Open();
        return tab;
      }
    },
    AnswerForward: {
      OpenTab: (
        data: {
          Mode: 'answer' | 'forward',
          Message: any,
          MessageRecipients: any,
          MessageAttachments: any[],
          LinkedCases: any[],
          LinkedTasks: any[],
          SelectedFkID: string | undefined },
        config?: ExgAppControllerConfig
      ): ExgApplicationTab => {
        const tab = new ExgApplicationTab('loading...'
          , TabMessageAnswerForwardComponent
          , data
          , 'Answer' + data.Message.msgID
          , {
            Close: () => {
              config?.Events?.Message?.AnswerForward?.Closed?.emit();
            }
          },
          true);
        tab.Open();
        return tab;
      }
    }
  };
  Note = {
    OpenModal: (data: any, config?: ExgAppControllerConfig): Subscription => {
      const sub = this.modalSrv.show('ModalNoteEditComponent', data).subscribe((changed) => {
        config?.Events?.NoteDialog?.Closed?.emit({success: changed});
      });
      return sub;
    }
  };
  Receipt = {
    Upload: {
      OpenModal: (data: any, config?: ExgAppControllerConfig): Subscription => {
        const sub = this.modalSrv
          .show(
            'ReceiptFileUploadComponent'
            , data)
          .subscribe(
            (rtVal: any) => {
              if (rtVal) {
                const receiptEndpoint = rtVal.mergeFileUpload && !rtVal.skipFileUpload ? 'ReceiptC_Merge' : 'ReceiptC';

                this.excRest.post(
                  this.excRest.computeUrl(receiptEndpoint, {rcptStatement: data.Data.rcptStatement}), rtVal.formData
                ).subscribe((ret: any) => {
                  if (ret) {
                    this.modalSrv
                      .showToast(
                        ret.success
                          ? this.getGlobal('Created')
                          : this.getGlobal('Abbruch')
                        , 'md-toast'
                        , ret.success ? 'fad fa-cloud-upload-alt' : 'fal fa-times-circle');

                    config?.Events?.Receipt?.UploadDialog?.Closed?.emit({success: ret});
                  }

                });
              }
            }
          );
        return sub;
      },
      OpenModalCU_File: (rcptID: any, data: any, config?: ExgAppControllerConfig): Subscription => {
        const sub = this.modalSrv.show('ReceiptFileReplaceUploadComponent', data)
          .subscribe(
            (rtVal: any) => {
              if (rtVal) {
                rtVal.formData.set('DataObject', JSON.stringify(data));
                this.excRest.post(
                  this.excRest.computeUrl('ReceiptCU_File', {rcptID}), rtVal.formData
                ).subscribe((ret: any) => {
                  if (ret) {
                    this.modalSrv
                      .showToast(
                        ret
                          ? this.getGlobal('Created')
                          : this.getGlobal('Abbruch')
                        , 'md-toast'
                        , ret ? 'fad fa-cloud-upload-alt' : 'fal fa-times-circle');

                    config?.Events?.Receipt?.UploadDialog?.Replaced?.emit({success: ret});
                  }

                });
              }
            }
          );
        return sub;
      },
      OpenModalU_AddFile: (rcptID: any, data: any, config?: ExgAppControllerConfig): Subscription => {
        const sub = this.modalSrv.show('ReceiptFileAddUploadComponent', data)
          .subscribe(
            (rtVal: any) => {
              if (rtVal) {
                rtVal.formData.set('DataObject', JSON.stringify(data));
                this.excRest.post(
                  this.excRest.computeUrl('ReceiptU_AddFile', {rcptID}), rtVal.formData
                ).subscribe((ret: any) => {
                  if (ret) {
                    this.modalSrv
                      .showToast(
                        ret
                          ? this.getGlobal('Created')
                          : this.getGlobal('Abbruch')
                        , 'md-toast'
                        , ret ? 'fad fa-cloud-upload-alt' : 'fal fa-times-circle');

                    config?.Events?.Receipt?.UploadDialog?.Replaced?.emit({success: ret});
                  }

                });
              }
            }
          );
        return sub;
      }
    },
    Checkview: {
      OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...', ReceiptCheckviewComponent,
          {rcptID: data, reloadOpenerView: config?.reloadOpenerView, checkRestore: false}, data);
        tab.Open();
        return tab;
      },
      OpenTabAfterSwitch: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...', ReceiptCheckviewComponent,
          {rcptID: data, reloadOpenerView: config?.reloadOpenerView, checkRestore: true}, data);
        tab.Open();
        return tab;
      },
      OpenCollectionTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...',
          ReceiptCollectionCheckviewViewerComponent,
          data,
          data,
        );
        tab.Open();
        return tab;
      }
    },
    StatementCheckview: {
      OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...', ReceiptStatementCheckviewComponent,
          {rcptID: data, reloadOpenerView: config?.reloadOpenerView}, data);
        tab.Open();
        return tab;
      },
    },
    Reporting: {
      openCaseReport: (auID: any, pdf = true, config?: ExgAppControllerConfig): void => {
        if (pdf) {
          this.modalSrv.show('ReceiptReportComponent', {})
            .subscribe((reportParams: any) => {
              if (reportParams) {
                this.excRest.get(
                this.excRest.computeUrl('Case_Report_fileTypeEx'
                  , {
                  auID,
                  fileType: pdf ? 'pdf' : 'xlsx',
                  extensions:
                    !reportParams.withReceipts && !reportParams.withReviews ? 0 :
                      reportParams.withReviews && !reportParams.withReceipts ? 2 :
                        reportParams.withReceipts  && !reportParams.withReviews ? 1 : 3
                }), {export: true}).subscribe(() => {
                  config?.Events?.Receipt?.Preview?.Downloaded?.emit();
                });
              }
        });
      } else {
          this.excRest.get(this.excRest.computeUrl('Case_Report_fileType', {
            auID, fileType: pdf ? 'pdf' : 'xlsx'
          }), {export: true}).subscribe(() => {
            config?.Events?.Receipt?.Preview?.Downloaded?.emit();
          });
        }
      },
      openTaskReport: (vorgID: any, pdf = true, config?: ExgAppControllerConfig): void => {
        if (pdf) {
          this.modalSrv.show('ReceiptReportComponent', {})
            .subscribe((reportParams: any) => {
              if (reportParams) {
                this.excRest.get(
                  this.excRest.computeUrl(
                    'Task_Report_fileTypeEx',
                    {
                      vorgID,
                      fileType: pdf ? 'pdf' : 'xlsx',
                      extensions:
                        !reportParams.withReceipts && !reportParams.withReviews ? 0 :
                          reportParams.withReviews && !reportParams.withReceipts ? 2 :
                            reportParams.withReceipts  && !reportParams.withReviews ? 1 : 3
                    }), {export: true}
                ).subscribe(() => {
                  config?.Events?.Receipt?.Preview?.Downloaded?.emit();
                });
              }
            });
        } else {
          this.excRest.get(
            this.excRest.computeUrl(
              'Task_Report_fileType',
              {
                vorgID, fileType: pdf ? 'pdf' : 'xlsx'
              }), {export: true}
          ).subscribe(() => {
            config?.Events?.Receipt?.Preview?.Downloaded?.emit();
          });
        }
      }
    },
    ObjectEditor: {
      OpenModal: (data: any, config?: ExgAppControllerConfig): Observable<any>  => {
        return this.modalSrv.show('ReceiptObjectEditorComponent', data);
      }
    }
  };
  History = {
    OpenModal: (data: any, config?: ExgAppControllerConfig): Subscription => {
      return this.modalSrv.show('ModalHistoryComponent', data).subscribe();
    }
  };
  Document = {
    Upload: {
      uploadProgress: 0,
      uploadCount: 0,
      OpenModal: (data: any, config?: ExgAppControllerConfig): Subscription => {
        return this.modalSrv
          .show('ModalAttachmentUploadComponent', {})
          .subscribe(
            (rtVal: any) => {
              // Reset Progress
              this.Document.Upload.uploadProgress = 0;
              this.Document.Upload.uploadCount = 0;

              if (rtVal) {
                this.Document.Upload.uploadCount = rtVal.formData?.length;

                const myPromise =
                  (formData: any) => {
                    return new Promise(
                      res => {
                        res(this.Document.Upload.Request(data, formData, config));
                      });
                };
                const source = of(rtVal.formData);
                const example =
                  source.pipe(
                    mergeMap(q => forkJoin(...q.map(myPromise))));

                example.subscribe(
                (rtValue) => console.log('return Upload1', rtValue)
                );
              }
            });
      },
      OpenModalv2: (data: any, config?: ExgAppControllerConfig): Subscription => {
        return this.modalSrv
          .show('ModalAttachmentUploadV2Component', data)
          .subscribe(
            (rtVal: {formDataArray: Array<Array<any>>}) => {

              // Reset Progress
              this.Document.Upload.uploadProgress = 0;
              this.Document.Upload.uploadCount = 0;


              if (rtVal?.formDataArray?.length > 0) {
                this.Document.Upload.uploadCount = rtVal.formDataArray
                  .map(fd => fd?.length || 0) // Hole die Länge jedes formData-Elements
                  .reduce((sum, length) => sum + length, 0); // Summiere die Längen auf

                for (const formdata of rtVal.formDataArray) {
                  const myPromise =
                    (formData: any) => {
                      return new Promise(
                        res => {
                          res(this.Document.Upload.Request({dok_objID: data.dok_objID}, formData, config));
                        });
                    };
                  const source = of(formdata);
                  const example =
                    source.pipe(
                      mergeMap(q => forkJoin(...q.map(myPromise))));

                  example.subscribe(
                    (rtValue) => console.log(rtValue)
                  );
                }
              }
            });
      },
      UploadFormdata: (data: any, formData: any, config?: ExgAppControllerConfig): Subscription => {
        return new Observable(observer => {
          // Reset Progress
          this.Document.Upload.uploadProgress = 0;
          this.Document.Upload.uploadCount = 0;

          if (formData) {
            this.Document.Upload.uploadCount = formData.length;

            console.log('formdata: ', formData);
            console.log('formdata length: ', formData.length);

            const myPromise = (dataEntry: any) => {
              return new Promise(res => {
                res(this.Document.Upload.Request(data, dataEntry, config));
              });
            };

            const source = of(formData);
            const example = source.pipe(
              mergeMap(q => forkJoin(...q.map(myPromise)))
            );

            example.subscribe({
              next: (rtValue) => {
                console.log(rtValue);
                observer.next(rtValue);
              },
              error: (err) => {
                console.error(err);
                observer.error(err);
              },
              complete: () => observer.complete()
            });
          } else {
            observer.error(new Error('No formData provided'));
          }
        }).subscribe();
      },
      Request: (data: any, formData: any, config?: ExgAppControllerConfig): any => {
        let lastValue = 0;
        this.excRest.post(
          this.excRest.computeUrl('DocumentC', data),
            formData, {
              OnProgress: (value: any) => {
                this.Document.Upload.uploadProgress -= lastValue;
                this.Document.Upload.uploadProgress += value - 1;

                this.Document.Upload.showRequestProgress();

                lastValue = value - 1;
              }
            })
          .subscribe(
            (ret: any) => {
              console.log(ret);
            }, (ret: any) => {
              config?.Events?.Document?.UploadDialog?.Closed?.emit({success: false});
            }, () => {
              this.Document.Upload.uploadProgress += 1;

              if (this.Document.Upload.uploadProgress === this.Document.Upload.uploadCount * 100) {
                this.modalSrv
                  .showToast(
                    `${this.getGlobal('Success')}`
                    , `md-toast bg-green`
                    , 'fal fa-cloud-upload-alt'
                  );
                config?.Events?.Document?.UploadDialog?.Closed?.emit({success: true});
              }
            });
      },
      SaveAsNewRequest: (data: any, formData: any, config?: ExgAppControllerConfig): any => {
        let lastValue = 0;
        // Reset Progress
        this.Document.Upload.uploadProgress = 0;
        this.Document.Upload.uploadCount = 1;
        this.excRest.post(
          this.excRest.computeUrl('DocumentC', data),
          formData, {
            OnProgress: (value: any) => {
              this.Document.Upload.uploadProgress -= lastValue;
              this.Document.Upload.uploadProgress += value - 1;

              this.Document.Upload.showRequestProgress();

              lastValue = value - 1;
            }
          })
          .subscribe(
            (ret: any) => {
              config?.Events?.Document?.UploadSaveAsNewDialog?.Closed?.emit({success: ret});
            }, (ret: any) => {
              config?.Events?.Document?.UploadSaveAsNewDialog?.Closed?.emit({success: false});
            }, () => {
              this.Document.Upload.uploadProgress += 1;

              if (this.Document.Upload.uploadProgress === this.Document.Upload.uploadCount * 100) {
                this.modalSrv
                  .showToast(
                    `${this.getGlobal('Success')}`
                    , `md-toast bg-green`
                    , 'fal fa-cloud-upload-alt'
                  );
              }
            });
      },
      SaveEditRequest: (data: any, formData: any, config?: ExgAppControllerConfig): any => {
        let lastValue = 0;
        // Reset Progress
        this.Document.Upload.uploadProgress = 0;
        this.Document.Upload.uploadCount = 1;
        this.excRest.post(
          this.excRest.computeUrl('DocumentU_File', data),
          formData, {
            OnProgress: (value: any) => {
              this.Document.Upload.uploadProgress -= lastValue;
              this.Document.Upload.uploadProgress += value - 1;

              this.Document.Upload.showRequestProgress();

              lastValue = value - 1;
            }
          })
          .subscribe(
            (ret: any) => {
              config?.Events?.Document?.UploadSaveEditDialog?.Closed?.emit({success: ret});
            }, (ret: any) => {
              config?.Events?.Document?.UploadSaveEditDialog?.Closed?.emit({success: false});
            }, () => {
              this.Document.Upload.uploadProgress += 1;

              if (this.Document.Upload.uploadProgress === this.Document.Upload.uploadCount * 100) {
                this.modalSrv
                  .showToast(
                    `${this.getGlobal('Success')}`
                    , `md-toast bg-green`
                    , 'fal fa-cloud-upload-alt'
                  );
              }
            });
      },
      showRequestProgress: (): void => {
        this.modalSrv
          .showToast(
            `${Math.round(this.Document.Upload.uploadProgress / this.Document.Upload.uploadCount)} % hochgeladen`
            , 'md-toast app-opacity'
            , 'fad fa-cloud-upload-alt');
      },
    },
    Update: {
      OpenModal: (data: any, config?: ExgAppControllerConfig): Subscription => {
        return this.modalSrv
          .show('ModalAttachmentUpdateComponent', data)
          .subscribe(
            (rtVal: any) => {
              if (rtVal) {
                this.excRest.post(
                  this.excRest.computeUrl('DocumentU', data), rtVal
                ).subscribe((ret: any) => {
                  if (ret) {
                    config?.Events?.Document?.UpdateDialog?.Closed?.emit({success: ret});
                  }
                });
              }
            });
      }
    },
    Manager: {
      OpenOverlay: (data?: any): Subscription => {
        return this.overlaySrv
          .show(
            'OverlayFileManagementComponent', data, true
          ).subscribe((ret: any) => {

          });
      }
    },
    Preview: {
      OpenModal: (data: any, config?: ExgAppControllerConfig): Subscription => {
        return this.modalSrv.show('ModalImageViewerComponent', data)
          .subscribe((ret: any) => {
            config?.Events?.Document?.PreviewDialog?.Closed?.emit({success: ret});
          });
      }
    },
    DokEdit: {
      OpenModal: (item: any, config?: ExgAppControllerConfig): Subscription => {
        return this.modalSrv
          .show('ModalImageEditorComponent', {item})
          .subscribe(
            (rtVal: any) => {
              if (rtVal?.save) {
                config?.Events?.ImageEditor?.OpenModal.ClosedSave.emit({success: true, data: rtVal});
              }
              else if (rtVal?.saveAsNew) {
                config?.Events?.ImageEditor?.OpenModal.ClosedSaveAs.emit({success: true, data: rtVal});
              }
              else if (rtVal?.reset) {
                config?.Events?.ImageEditor?.OpenModal.ClosedReset.emit({success: true, data: rtVal});
              }
              else {
                /*canceled*/
                config?.Events?.ImageEditor?.OpenModal.Canceled.emit({success: false});
              }
            });
      },
      ResetEditRequest: (data: any, config?: ExgAppControllerConfig): any => {
        this.excRest
          .put(this.excRest.computeUrl('DocumentD', {dokID: data.dokID}), {})
          .subscribe((ret: any) => {
            if (ret) {
              this.modalSrv
                .showToast(
                  ret.success ? 'Bearbeitung zurückgesetzt' : 'Zurücksetzen fehlgeschlagen'
                  , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                  , ret.success ? 'fa-duotone fa-trash-can-check' : 'fa-regular fa-times-circle');
            }
            if (ret) {
              config?.Events?.Document?.ResetEditDialog?.Closed?.emit({success: true, data: ret});
            }
            else {
              config?.Events?.Document?.ResetEditDialog?.Closed?.emit({success: false});
            }
          });
      }
    }
  };
  DocumentTemplate = {
    Download: (vorgID: any, dotID: any): void => {
      const queryParams: { [key: string]: any } = {
        dotID,
        fill: true,
        oid: vorgID
      };
      this.excRest.get(
        this.excRest.computeUrl(
          'DocumentTemplateR',
          queryParams),
        {export: true}
      ).subscribe();
    }
  };
  Report = {
    New: (data: any, config?: ExgAppControllerConfig): void => {
      window.open(this.excRest.computeUrl('ReportModuleNewReport', {vorgID: data}), '_blank');
    },
    Open: (data: any, config?: ExgAppControllerConfig): void => {
      window.open(this.excRest.computeUrl('ReportModuleOpenReport', {fbaID: data}), '_blank');
    }
  };
  OE = {
    Workspace: {
      OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab('loading...', OeWorkspaceComponent, {oeID: data}, data);
        tab.Open();
        return tab;
      },
      OpenDefaultOETab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab('loading...', OeWorkspaceComponent, {oeID: data, defaultOE: true}, data);
        tab.Open();
        return tab;
      },
    },
    NewOE: {
      OpenModal: (data: { oeIDparent?: string, isCompany?: boolean }, config?: ExgAppControllerConfig): Subscription => {
        return this.modalSrv.show('ModalOeEditorComponent', data).subscribe((rtVal: any) => {
          if (rtVal) {
            if (!data.oeIDparent) { data.oeIDparent = '00000000-0000-0000-0000-000000000000'; }
            this.excRest.post(this.excRest.computeUrl('OeC'), {...rtVal, ...data}).subscribe((rslt: any) => {
              if (rslt?.data?.OE) {
                config?.Events?.OE?.NewOE?.Save.emit({success: true, data: rslt.data.OE});
              } else {
                config?.Events?.OE?.NewOE?.Canceled.emit({success: false});
              }
            });
          } else {
            /*canceled*/
            config?.Events?.OE?.NewOE?.Canceled.emit({success: false});
          }
        });
      }
    },
    OeEditor: {
      OpenModal: (data: { oeID?: string,
                          isNew?: boolean,
                          showAssignButton?: boolean,
                          isCompany?: boolean,
                          oeIDparent?: string,
                          predefinedCrmRolle?: number,
                          predefinedEnmIdentOETyp?: number}
                , config?: ExgAppControllerConfig): Subscription => {
        return data.oeID ?
            this.excRest.get(
              this.excRest.computeUrl('OESummary_Short', {
                oeID: data.oeID
              }), {
                MetaInfo: {}
            })
            .subscribe(
              (resultData: any) => {
                if (resultData && resultData.data) {
                  this.modalSrv.show('ModalOeComponent', {
                      new: data.isNew,
                      OEDetails: resultData.data.OEDetails,
                      Contacts: resultData.data.Contacts,
                      Addresses: resultData.data.Addresses,
                      showAssignButton: data.showAssignButton,
                      isCompany: data.isCompany,
                      oeIDparent: data.oeIDparent,
                      predefinedCrmRolle: data.predefinedCrmRolle,
                      predefinedEnmIdentOETyp: data.predefinedEnmIdentOETyp
                    }, true)
                    .subscribe((modalData: any) => {
                      if (modalData && modalData.OEDetails) {
                        config?.Events?.OE?.NewOE?.Save.emit({success: true, data: modalData.OEDetails});
                      } else {
                        config?.Events?.OE?.NewOE?.Canceled.emit({success: false});
                      }
                    });
                }
              }
            )
          : this.modalSrv.show('ModalOeComponent', {new: data.isNew,
            oeIDparent: data.oeIDparent,
            showAssignButton: data.showAssignButton,
            isCompany: data.isCompany,
            predefinedCrmRolle: data.predefinedCrmRolle,
            predefinedEnmIdentOETyp: data.predefinedEnmIdentOETyp}, true)
              .subscribe((modalData: any) => {
                if (modalData && modalData?.OEDetails) {
                  config?.Events?.OE?.NewOE?.Save.emit({success: true, data: modalData.OEDetails});
                } else {
                  config?.Events?.OE?.NewOE?.Canceled.emit({success: false});
                }
              });
      }
    }
  };
  Formular = {
    Version: {
      OpenTab: (data: any,  config?: ExgAppControllerConfig): ExgApplicationTab => {
        data.Events = config?.Events;
        const tab = new ExgApplicationTab(
          data.frmVName ?? data.frmTName,
          FormularVersionComponent,
          data,
          data.frmVID ?? data.frmTID,
          {
            Close: () => {
              config?.Events?.Formular?.Version?.Closed?.emit();
            }
          },
          true,
          'far fa-pen-field'
        );
        tab.Open();
        return tab;
      },
    }
  };
  QuestionnaireVersion = {
    OpenTab: (data: { qcnfID: string, qverID?: string, isTest: boolean, qverName: string },
              config?: ExgAppControllerConfig): ExgApplicationTab => {
      const tab = new ExgApplicationTab(
        data.qverName,
        QuestionnaireRendererComponent,
        data,
        data.qverID,
        {
          Close: () => {
            config?.Events?.Message?.Reader?.Closed?.emit();
          }
        },
        true,
        'far fa-clipboard-list'
      );
      tab.Open();
      return tab;
    },
    OpenModal: (data: any, config?: ExgAppControllerConfig): Subscription => {
      return this.modalSrv.show('ModalQuestionnaireVersionComponent', data)
        .subscribe((ret: any) => {
          console.log(ret);
          if (ret && ret.created && ret.questVersion) {
            const dataObj = {
              qcnfID: ret.questVersion.qver_qcfgID,
              qverID: ret.questVersion.qverID,
              isTest: false,
              qverName: ret.questVersion.qverName
            };
            this.QuestionnaireVersion.OpenTab(dataObj, config);
          }
          config?.Events?.Questionnaire?.CreateUpdateVersion?.Closed?.emit({success: ret, data});
        });
    },
    ExportExcelReport: (data: any): void => {
      window.open(this.excRest.computeUrl('QuestionnaireVersionR_Report', {qverID: data}), '_blank');
    },
    ExportPDFReport: (data: any): void => {
      window.open(this.excRest.computeUrl('QuestionnaireVersionR_Summary_Report', {qverID: data}), 'newWindow', 'width=800,height=600,scrollbars=yes,resizable=yes');
    }
  };
  LinkedObject = {
    OpenLink: (data: any, config?: ExgAppControllerConfig): void => {
      switch (data.lnkTable) {
        case 'Notiz':
          this.Note.OpenModal({ntzID: data.lnkID}, config);
          break;
        case 'Nachricht':
          this.Message.Reader.OpenTab({msgID: data.lnkID, fkID: data.lnk_objID}, config);
          break;
        case 'FragebogenAusgefuellt':
          this.Report.Open(data.lnkID, config);
          break;
        case 'Fragebogen':
          this.QuestionnaireVersion.OpenTab({ qcnfID: data.lnkSubTyp, qverID: data.lnkID, isTest: false, qverName: data.lnkName});
          break;
      }
    }
  };
  PhotoDocumentation = {
    Download: (pdID: any, config?: ExgAppControllerConfig): void => {
      const URL = this.excRest.computeUrl('PhotoDocumentationR_Download', {pdID});
      this.excRest.get(URL, {export: true}).subscribe((ret: any) => {
        if (ret.success) {
          config?.Events?.PhotoDocumentation?.Download?.Finished?.emit({success: ret});
        }
        else {
          config?.Events?.PhotoDocumentation?.Download?.Finished?.emit({success: false});
        }
      });
    },
    PreviewModal: (data: any, config?: ExgAppControllerConfig): void => {
      const createURL = this.excRest.computeUrl('PhotoDocumentationC', {FKID: data.FKID});
      this.excRest.post(createURL, data)
        .subscribe((ret: any) => {
          if (ret.success && ret.data.PhotoDocumentation.pdID) {
            const url = this.excRest.computeUrl('PhotoDocumentationR_Preview', {pdID: ret.data.PhotoDocumentation.pdID});
            config?.Events?.PhotoDocumentation?.PreviewModal?.Success?.emit({success: true});
            this.modalSrv.show('ModalPreviewPhotoDocComponent', { url }).subscribe((rslt: any) => {
              const deleteURL = this.excRest.computeUrl('PhotoDocumentationD', {pdID: ret.data.PhotoDocumentation.pdID});
              this.excRest.delete(deleteURL, {pdUPT: ret.data.PhotoDocumentation.pdUPT}).subscribe((res: any) => {});
            });
          }
          else {
            this.modalSrv.showToast('Zusamenführung fehlgeschlagen', 'md-toast', 'fas fa-exclamation');
            config?.Events?.PhotoDocumentation?.PreviewModal?.Success?.emit({success: false});
          }
        });
    }
  };
  ReportBuilder = {
    DocBuilder: {
      OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab('loading...'
          , ReportDocBuilderComponent
          , data
          , data?.vorgID ? data.vorgID : data.auID
          , {
            Close: () => {/*
              config?.Events?.ReportBuilder?.OpenTab?.Closed?.emit();*/
            }
          },
          true);
        tab.Open();
        return tab;
      },
      PreviewCreate: (data: any, config?: ExgAppControllerConfig): void => {
        this.excRest.post(
          this.excRest.computeUrl('BerichtsBuilderPreviewC'), data
        ).subscribe((response: any) => {
          if (response?.data?.ReportBuilderPreview) {
            config?.Events?.ReportBuilder?.Preview?.Create.emit({success: true, data: response.data.ReportBuilderPreview});
          } else {
            config?.Events?.ReportBuilder?.Preview?.Create.emit({success: false});
          }
        });
      }
    },
    ReportReview: {
      OpenOverlay: (data?: any, config?: ExgAppControllerConfig): Subscription => {
        return this.overlaySrv
          .show(
            'OverlayReportPreviewComponent', data, true
          ).subscribe((ret: any) => {
            config?.Events?.ReportBuilder.PreviewOverlay.Closed.emit({ data });
          });
      }
    }
  };

  helperObj = {
    clone(cloneObj: any): any {
      return JSON.parse(JSON.stringify(cloneObj));
    },
    changed(objBefore: any, objAfter: any): boolean {
      return JSON.stringify(objBefore) !== JSON.stringify(objAfter);
    }
  };
  table = {
    isLoading: (table: any): boolean => {
      return table?.isLoading;
    },
    isEmpty: (table: any): boolean => {
      return table?.data.length === 0 && !this.isTableLoading(table);
    },
  };
  metaInfo = {
    dataFilter: (uiFilterEnumGroup = [] as any[], uiFilterSearchFields = [] as any[]): any[] => {
      const uiFilter = [];

      for (const configEnm of uiFilterEnumGroup) {
        for (const enm of this.enumSrv.getEnumerationList(configEnm.enmName)) {
          const obj = {
            filterType: 1,
              filterGroup: this.enumSrv.getFieldCaption(configEnm.enmTable, configEnm.enmField),
            filterField: configEnm.enmField,
            filterIdent: enm.enmIdent,
            uiCaption:
            (!configEnm.enmAlt ? enm.enmText : enm.enmTextA).slice(0, 32) +
            ((!configEnm.enmAlt ? enm.enmText : enm.enmTextA).length > 32
              ? '..'
              : ''),
              filterCondition: { operator: '=', value: enm.enmIdent },
            uiName: enm.enmText,
            uiValue: configEnm?.defaultValues ?
                        !!configEnm?.defaultValues.find((defaultValue: number) => defaultValue === enm.enmIdent)
                      : false,
          };
          if (configEnm?.enmAltTT) {
            Object.assign(obj, { uiTooltip: enm.enmTextA });
          }
          uiFilter.push(obj);
        }
      }
      for (const field of uiFilterSearchFields) {
        if (!(ExcCoreModule.Array.GetObject(uiFilter, 'filterField', field.tableField) &&
          ExcCoreModule.Array.GetObject(uiFilter, 'filterGroup', field.groupCaption ? field.groupCaption : field.table))) {
          uiFilter.push({
            filterType: 2,
            filterGroup: field.groupCaption ? field.groupCaption : field.table,
            filterField: field.tableField,
            uiCaption:
              field.tableFieldCaptionAlt && field.tableFieldCaptionAlt.length > 0 ? field.tableFieldCaptionAlt :
                this.enumSrv
                  .getFieldCaption(
                    field.table,
                    !field.repColumn
                      ? field.table !== 'All'
                        ? field.tableField
                        : field.tableField
                          .replace('au', '%').replace('vorg', '%').replace('rcpt', '%').replace('msg', '%').replace('api', '%')
                      : field.repColumn
                  )
                  .slice(0, 32) +
                (this.enumSrv.getFieldCaption(field.table, field.tableField)
                  .length > 32
                  ? '..'
                  : ''),
            filterCondition: { operator: 'like', value: field.defaultValue && field.defaultValue.length > 0 ? field.defaultValue : '' },
            uiName: field.tableField,
            uiValue: false,
          });
        }
      }

      return uiFilter;
    }, dataSort: (uiSortFieldGroup = [] as any[]): any[] => {
      const uiSort = [] as any[];

      for (const sortObject of uiSortFieldGroup) {
        if (!(ExcCoreModule.Array.GetObject(uiSort, 'sortField', sortObject.fieldName) &&
          ExcCoreModule.Array.GetObject(uiSort, 'sortGroup', sortObject.fieldGroup))) {
          uiSort.push({
            sortGroup: sortObject.fieldGroup,
            sortField: sortObject.fieldName,
            sortDefault: 0,
            uiCaption: sortObject?.uiName ? sortObject.uiName :
              this.enumSrv.getFieldCaption(
                sortObject.fieldTable ,
              sortObject.fieldTable !== 'All'
                ? sortObject.fieldName
                : sortObject.fieldName
                  .replace('au', '%').replace('vorg', '%').replace('rcpt', '%').replace('msg', '%').replace('api', '%')
            ),
            uiValue: 0,
          });
        }
      }

      return uiSort;
    }, uiFilterAktiv: (uiFilter = [] as any[], filterType?: number): any[] => {
      return uiFilter
        .filter((filters: any) =>
          ((filters.uiValue === true && filters.filterType === 1)
            || (filters.filterCondition.value.length > 0 && filters.filterType === 2))
          && (!filterType || (filterType === filters.filterType)))
        .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType));
    }, uiSortAktiv: (uiSort = [] as any[]): any[] => {
      // tslint:disable-next-line:indent
      return uiSort.filter((sort: any) => sort.uiValue === true);
    },
  };

  file = {
    FILE_SIZE_UNITS: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    FILE_SIZE_UNITS_LONG: ['Bytes', 'Kilobytes', 'Megabytes', 'Gigabytes', 'Pettabytes', 'Exabytes', 'Zettabytes', 'Yottabytes'],
    dokument: {
      download: (dokID: any): void => {
        const queryParams: { [key: string]: any } = {
          dokID,
          export: true
        };
        const url = this.excRest.computeUrl('DocumentR', queryParams);
        this.excRest.get(url, {export: true}).subscribe();
      },
      openInBrowser: (dokID: any): void => {
        const queryParams: { [key: string]: any } = { dokID, export: false };
        const url = this.excRest.computeUrl('DocumentR', queryParams);
        const windowFeatures = 'width=800,height=600,scrollbars=yes,resizable=yes';
        window.open(
          this.excRest.computeUrl(url, {}),
          'newWindow',
          windowFeatures
        );
      }
    },

    library: {
      openInBrowser: (item: any): void => {
        const url = this.excRest.computeUrl('LibraryDetail', { libID: item.libID });
        const previewWindow = window.open('', 'newWindow', 'width=800,height=600,scrollbars=yes,resizable=yes');

        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const file = new Blob([blob], { type: item.libMimeType });
            const fileUrl = URL.createObjectURL(file);

            if (previewWindow) {
              previewWindow.location.href = fileUrl;
            }
          });
      }
    },

    calcFileSize: (sizeInBytes: number, longForm: boolean = false): string => {
      const units = longForm
        ? this.file.FILE_SIZE_UNITS_LONG
        : this.file.FILE_SIZE_UNITS;
      const power = Math.min(Math.floor(Math.log(sizeInBytes) / Math.log(1024)), units.length - 1);
      // power = Math.min(power, units.length - 1);
      const size = sizeInBytes / Math.pow(1024, power); // size in new units
      const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
      const unit = units[power];
      return `${formattedSize} ${unit}`;
    }
  };
  toast = {
    Message: (msg: string, icon: string, additionalClasses?: string | ''): void => {
      this.modalSrv
        .showToast(msg
          , `md-toast ${additionalClasses}`
          , icon);
    }
  };
  VnData = {
    AddData: (taskSummary: any, config?: ExgAppControllerConfig): void => {
      const vnOeID = taskSummary?.caseDetails?.data?.aue_oeID_VN;
      if (!vnOeID || vnOeID === '00000000-0000-0000-0000-000000000000') {
        this.modalSrv.showToast(
          this.getRessource('AddVNData.NoVN'),
          'md-toast bg-orange',
          'fas fa-exclamation'
        );
        return;
      }

      const oeData = taskSummary?.oeList?.data?.find((oe: any) => oe.oeID === vnOeID);
      const emailList = (oeData?.contacts ?? []).filter((k: any) =>
        k.kont_enmIdent_KontaktTyp === 3 || k.kont_enmIdent_KontaktTyp === 28
      );

      this.modalSrv.show('ModalVnDataComponent', {
        aueReserve: taskSummary?.caseDetails?.data?.aueReserve,
        aueSelbstbehalt: taskSummary?.caseDetails?.data?.aueSelbstbehalt,
        emailList
      }).subscribe((modalResponse: any) => {
        if (!modalResponse) { return; }

        const EIS_SERVICEDESK_KONT_ID = 'AB32F744-A545-4072-B76E-C12F9A80C341';
        const vorgNr = taskSummary?.taskDetails?.data?.vorgNr;
        const auID = taskSummary?.caseDetails?.data?.auID;

        const postfachItem = this.enumSrv.getEnumerationList('Postfach').find((e: any) =>
          e.enmSelector === taskSummary?.caseDetails?.data?.au_oeID_Auftraggeber
        ) || this.enumSrv.getEnumerationDefaultItem('Postfach');

        const payload: any = {
          oeID: vnOeID,
          msg_objID: taskSummary?.ID,
          msg_enmIdent_NachrichtTyp: 1,
          msg_enmIdent_NachrichtPrio: this.enumSrv.getEnumerationDefaultValue('NachrichtPrio'),
          msg_enmIdent_Postfach: postfachItem?.enmIdent,
          msgNachrichtKategorie_enmIdent: this.enumSrv.getEnumerationDefaultValue('NachrichtKategorie'),
          msgAbsender: postfachItem?.enmTextA,
          msgEmpfaengerKontID: EIS_SERVICEDESK_KONT_ID,
          msgEmpfaengerKontVal: 'EIS-ServiceDesk'
        };
        let notifyText = '';

        if (modalResponse.email) {
          const hasHEmail = emailList.some((k: any) => k.kont_enmIdent_KontaktTyp === 28);
          payload.email_kontVal = modalResponse.email.kontVal;
          payload.email_enmIdent = hasHEmail ? 3 : 28;
          if (emailList.length > 0) {
            const currentEmail = emailList.map((k: any) => k.kontVal).join(', ');
            notifyText += `Alte E-Mail: ${currentEmail}<br>Neue E-Mail: ${modalResponse.email.kontVal}`;
          }
        }

        if (modalResponse.phone) {
          payload.phone_kontVal = modalResponse.phone.kontVal;
          payload.phone_enmIdent = modalResponse.phone.kont_enmIdent_KontaktTyp;
        }

        if (modalResponse.reserve || modalResponse.selbstbeteiligung) {
          const formatEuro = (val: any) =>
            Number(val).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

          const currentReserve = taskSummary?.caseDetails?.data?.aueReserve != null
            ? formatEuro(taskSummary.caseDetails.data.aueReserve) : '-';
          const currentSelbst = taskSummary?.caseDetails?.data?.aueSelbstbehalt != null
            ? formatEuro(taskSummary.caseDetails.data.aueSelbstbehalt) : '-';
          let schadensparameterText = '';

          if (modalResponse.reserve) {
            payload.aueReserve = modalResponse.reserve;
            schadensparameterText +=
              `Alte Excon Reserve: ${currentReserve} €<br>Neue Excon Reserve: ${formatEuro(modalResponse.reserve)} €`;
          }
          if (modalResponse.selbstbeteiligung) {
            payload.aueSelbstbehalt = modalResponse.selbstbeteiligung;
            if (schadensparameterText) { schadensparameterText += '<br><br>'; }
            schadensparameterText += `Alter Selbstbehalt: ${currentSelbst} €<br>Neuer Selbstbehalt: ${formatEuro(modalResponse.selbstbeteiligung)} €`;
          }
          const oldReserve = taskSummary?.caseDetails?.data?.aueReserve;
          if (modalResponse.reserve &&
             (oldReserve == null || Number(oldReserve) !==
             Number(modalResponse.reserve))) {

            if (notifyText) {
             notifyText += '<br><br>';
            }
            notifyText += schadensparameterText;
          }
        }

        if (modalResponse.comment) {
          if (notifyText) {
            notifyText += '<br><br>';
          }
          notifyText += modalResponse.comment.split('\n').join('<br>');
        }

        if (notifyText) {
          payload.comment = notifyText;
          payload.commentBetreff = `${vorgNr} VN Daten korrigieren`;
        }

        this.excRest.post(
          this.excRest.computeUrl('AddVNDataC', {auID}),
          payload
        ).subscribe((response: any) => {
          const success = response?.success;
          this.modalSrv.showToast(
            this.getRessource(success ? 'AddVNData.Success' : 'AddVNData.Failed'),
            `md-toast ${success ? 'bg-green' : 'bg-red'}`,
            success ? 'fas fa-check-circle' : 'fas fa-times-circle'
          );
          config?.Events?.VnData?.AddData?.Closed?.emit({ success });
          taskSummary?.LoadSummary();
        });
      });
    }
  };

  UserAttributes = () => {
    const attributesObject: {[key: string]: string} = {};
    const attributes = this.excSecurity.CurrentUser?.faAttributes;
    const attrArray = attributes?.split('||');
    if (attrArray) {
      for (let i = 0; i < attrArray.length; i++)
      {
        if (i === 0)
        {
          attrArray[i] = attrArray[i].substring(1);
        }
        if (i === attrArray.length - 1)
        {
          attrArray[i] = attrArray[i].substring(0, attrArray[i].length - 1);
        }
        const key = attrArray[i].split(':')[0];
        const value = attrArray[i].split(':')[1];
        attributesObject[key] = value;
      }
      return attributesObject;
    }
    return {};
  }

  constructor(
    private excRest: ExcRestService,
    private enumSrv: EnumerationService,
    private modalSrv: ExgModalService,
    private excSecurity: ExcSecurityService,
    private overlaySrv: ExgOverlayService,
    public AppSettings: SettingsApplicationService
  ) {
    super();
  }

  isTableLoading(table: any): boolean {
    return table?.isLoading;
  }

  isTableEmpty(table: any): boolean {
    return table?.data.length === 0 && !this.isTableLoading(table);
  }
}
